import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js'

export const registerChart = () => {
    ChartJS.register(ArcElement, Tooltip, Legend)
}
